<template>
<div class="row" v-if="accessDetails">
    <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink">
        <router-link to="/admin/sms">
            <div class="card bg-gradient-success">
                <div class="card-body text-center">
                    <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                        <i class="fa fa-building"></i>
                    </div>
                    <h5 class="card-title text-muted mb-0 text-white">School Portal</h5>
                    <p class="card-description">Manage school accounts and access the school administration portals.</p>
                </div>
            </div>
        </router-link>
    </div>
    <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink">
        <router-link to="/admin/eduschool">
            <div class="card bg-gradient-success">
                <div class="card-body text-center">
                    <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                        <i class="fa fa-graduation-cap"></i>
                    </div>
                    <h5 class="card-title text-muted text-white mb-0">EduSchool</h5>
                    <p class="card-description">Access education services and manage platform-wide school resources.</p>
                </div>
            </div>
        </router-link>
    </div>
    <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="accessDetails.isSuperAdmin">
        <router-link to="/admin/staff-registration">
            <div class="card bg-gradient-success">
                <div class="card-body text-center">
                    <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                        <i class="fa fa-users"></i>
                    </div>
                    <h5 class="card-title text-muted mb-0 text-white">Employee</h5>
                    <p class="card-description">Register and manage employee accounts across the platform.</p>
                </div>
            </div>
        </router-link>
    </div>
    <div class="col-12 col-sm-6 col-lg-4 col-xl-3 shrink" v-if="accessDetails.isSuperAdmin">
        <router-link to="/admin/sms-subscriptions-setup">
            <div class="card bg-gradient-success">
                <div class="card-body text-center">
                    <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                        <i class="fa fa-cogs"></i>
                    </div>
                    <h5 class="card-title text-muted mb-0 text-white">Settings</h5>
                    <p class="card-description">Configure portal services, subscriptions, and system options.</p>
                </div>
            </div>
        </router-link>
    </div>
   
</div>
</template>
<script>
export default {   
    data() {
    return {     
      onloader: "none",
      accessDetails:null,
    };
  },  
  mounted() {
        this.accessDetails = this.$store.getters['auth/_user'];
    }, 
}
</script>